import { toWSDateString } from "@wingspanhq/fe-component-library";
import { ICOIExtractionInterface } from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import startCase from "lodash/startCase";
import toLower from "lodash/toLower";
import upperFirst from "lodash/upperFirst";
import { DataItemProps } from "../../../../../../shared/components/DataView";
import { ArrayElement } from "../../../../../../types/utilities";
import { convertDateStringToUTCMidday } from "../../../../../../utils/dates";
const sentenceCase = (str: string) => upperFirst(toLower(startCase(str)));

export const mapCOIPolicyToDataView = (
  policy: ArrayElement<ICOIExtractionInterface["policies"]>
): DataItemProps[] => {
  const items: DataItemProps[] = [
    { label: "Policy number", value: policy.policyNumber },
    { label: "Insurer name", value: policy.insurerName },
    {
      label: "Policy effective dates",
      fullWidth: true,
      value:
        [
          policy.effectiveDate
            ? toWSDateString(
                convertDateStringToUTCMidday(policy.effectiveDate),
                "monthDayYear"
              )
            : null,
          policy.expirationDate
            ? toWSDateString(
                convertDateStringToUTCMidday(policy.expirationDate),
                "monthDayYear"
              )
            : null
        ].join(" - ") || "N/A"
    }
  ];

  if (policy.limits?.length) {
    items.push({
      fullWidth: true,
      label: `Limits`,
      value: policy.limits
        .map((limit, index) => {
          // TODO(artemk): update api interface
          return `• ${sentenceCase(limit.limitType ?? "")}: ${formatMoney(
            Number.parseFloat(limit.amount ?? "0"),
            limit.currency as Currency
          )} ${limit.currency ? `(${limit.currency})` : ""}`;
        })
        .join("\n")
    });
  }

  if (policy.appliedProvisions?.length) {
    items.push({
      label: "Applied provisions",
      fullWidth: true,
      value: policy.appliedProvisions
        .map((provision, index) => {
          const provisionType = sentenceCase(provision.provisionType || "");
          const condition = provision.condition
            ? `(${provision.condition})`
            : "";

          const basis = sentenceCase(provision.basis || "");
          const appliesTo = provision.appliesTo
            ? `Applies To: ${sentenceCase(provision.appliesTo)}`
            : "";

          const firstPart = [provisionType, condition]
            .filter(Boolean)
            .join(" ");
          const secondPart = [basis, appliesTo].filter(Boolean).join(" - ");

          return "• " + [firstPart, secondPart].filter(Boolean).join(": ");
        })
        .join("\n")
    });
  }

  return items;
};
